import {
  InventoryMeterMountType,
  CreateInventoryMeterOutputDto,
  UpdateInventoryMeterOutputDto,
  OutputTechnology,
} from '@enmon/commons/lib/tools';
import type { UploadFile } from 'antd/lib/upload/interface';
import type { SetState } from 'zustand';
import type { SerializedMeterRegister } from '@enmon/commons';
import type { InventorizeMeterStore } from '../../useStore';

const INITIAL_STATE: ReadingStepForm = {
  meterMountType: undefined,
  meterMountTechnology: undefined,
  remoteReadingOwner: undefined,
  remoteReadingSerial: undefined,
  requiresManualAks: false,
  photoMeterModuleList: undefined,
  registers: [{}],
  outputs: [],
  readingDate: undefined,
  readingGroup: undefined,
};

export type ReadingStepRegister = Partial<
  Pick<SerializedMeterRegister, '_id' | 'name' | 'unit'> & {
    fullObis?: {
      obis?: SerializedMeterRegister['obis'];
      tariff?: SerializedMeterRegister['tariff'];
    };
    readingCounter?: number;
    readingPhotos?: UploadFile[];
  }
>;

export interface ReadingStepForm {
  meterMountType?: InventoryMeterMountType;
  meterMountTechnology?: OutputTechnology;
  remoteReadingOwner?: string;
  remoteReadingSerial?: string;
  requiresManualAks?: boolean;
  readingDate?: string;
  photoMeterModuleList?: UploadFile[];
  registers?: ReadingStepRegister[];
  outputs?: Array<CreateInventoryMeterOutputDto | UpdateInventoryMeterOutputDto>;
  readingGroup?: number;
}

export type ReadingStepSlice = ReadingStepForm & {
  resetReadingStepSlice: (initValues?: Partial<ReadingStepForm>) => void;
  setReadingStepValues: (values: ReadingStepForm) => void;
  setPhotoModuleList: (payload: UploadFile[]) => void;
};

export const createReadingStepSlice = (set: SetState<InventorizeMeterStore>): ReadingStepSlice => ({
  ...INITIAL_STATE,
  setPhotoModuleList: (payload: UploadFile[]) =>
    set(() => ({
      photoMeterModuleList: payload,
    })),
  setReadingStepValues: (values: ReadingStepForm) => set(values),
  resetReadingStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
});
